export default {
  title: 'Sign up',
  username: 'Username',
  email: 'Email',
  mobile: 'Phone number',
  code: 'Verification code',
  password: 'Create password',
  confirm: 'Confirm password',
  agree: 'I agree',
  agreement: 'Fanhan Tech User Service Protocol',
  agreement2: '《泛函隐私政策》',
  register: 'Register',
  mailReg: 'Sign up with e-mail',
  phoneReg: 'Sign up with phone',
  js: {
    error: 'Failure',
    success: 'Success',
    sendAgain: 'Resend',
    send: 'Send code',
    check: 'Please check the agreement'
  },
  loginType: {
    password: 'Password login',
    sms: 'SMS login'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/register.js